import React from "react";
import { Modal, Form, Input, Select, Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

import { useTranslation } from "react-i18next";
const { TextArea } = Input;
const { Option } = Select;

const UploadDocumentModal = ({
  visible,
  onCancel,
  onSuccess,
  currentFolder,
  allFolders,
  apiUrl
}) => {
  const { t } = useTranslation("dashboard");
  const [form] = Form.useForm();

  const handleUpload = async values => {
    const formData = new FormData();
    formData.append("file", values.file.file);
    formData.append("name", values.name || values.file.file.name);
    formData.append("description", values.description || "");
    formData.append("folderId", values.folderId || currentFolder || "");

    try {
      await axios.post(`${apiUrl}/documents/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });

      message.success(t("Document uploaded successfully"));
      form.resetFields();
      onSuccess();
    } catch (error) {
      console.error("Upload error:", error);
      message.error(t("Failed to upload document"));
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={t("Upload Document")}
      open={visible}
      onCancel={handleCancel}
      width={600}
      destroyOnClose
      footer={
        <>
          <Button onClick={handleCancel}>{t("Cancel")}</Button>
          <Button type="primary" onClick={() => form.submit()}>
            {t("Upload")}
          </Button>
        </>
      }
    >
      <Form form={form} layout="vertical" onFinish={handleUpload}>
        <Form.Item
          name="file"
          label={t("Select File")}
          rules={[{ required: true, message: t("Please select a file") }]}
        >
          <Upload.Dragger
            name="file"
            multiple={false}
            beforeUpload={() => false}
            maxCount={1}
            onChange={info => {
              if (info.file) {
                form.setFieldsValue({ file: info });
              }
            }}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined />
            </p>
            <p className="ant-upload-text">{t("Click or drag file to this area to upload")}</p>
            <p className="ant-upload-hint">
              {t("Support for a single file upload. Maximum file size: 100MB")}
            </p>
          </Upload.Dragger>
        </Form.Item>

        <Form.Item name="name" label={t("Document Name")}>
          <Input placeholder={t("Enter document name (optional - will use filename if empty)")} />
        </Form.Item>

        <Form.Item name="description" label={t("Description")}>
          <TextArea
            rows={3}
            placeholder={t("Enter document description (optional)")}
            maxLength={500}
            showCount
          />
        </Form.Item>

        <Form.Item name="folderId" label={t("Folder")} initialValue={currentFolder}>
          <Select placeholder={t("Select folder (optional)")} allowClear>
            {allFolders.map(folder => (
              <Option key={folder._id} value={folder._id}>
                {folder.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UploadDocumentModal;
